import { render, staticRenderFns } from "./BlockedDashboard.vue?vue&type=template&id=2add589a&scoped=true"
import script from "./BlockedDashboard.vue?vue&type=script&lang=js"
export * from "./BlockedDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlockedDashboard.vue?vue&type=style&index=0&id=2add589a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add589a",
  null
  
)

export default component.exports